function eventosGTM () {

    const obtenerTLD = (dominio) => {
        const partesDominio = dominio.split(".");
        let tld = '';
        for (let i = 1; i < partesDominio.length; i++) {
            tld = tld + "." + partesDominio[i];
        }
        return tld;
    }
    
    const sendBeginCheckoutEvent = (currency, products, coupon = "", totalLocal) => {
        
        const listItem = products.map(item => ({
            item_id: item.product.id ? item.product.id :
                item.product.domain_section[0].domain_type === "register" ? "1" :
                item.product.domain_section[0].domain_type === "transfer" ? "2" :
                "3",
            item_name: (item.product.id) ? item.product.smallname : obtenerTLD(item.product.domain_section[0].dominio_principal),
            affiliation: "NEUBOX",
            discount: item.price.cross_price ? item.price.cost : "0",
            item_brand: "NEUBOX.COM",
            item_category: item.product.id ? item.product.name.split("-")[0].trim() : "Dominio",
            item_variant: item.periodo,
            price: item.price.second_price ? item.price.second_price : "0",
            quantity: 1,
        }));
    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "begin_checkout",
            ecommerce: {
                currency: currency,
                value: totalLocal,
                coupon: coupon,
                items: listItem
            }
        });
    };

    const sendAddPaymentInfoEvent = (currency, products, coupon = "", paymentMethod, totalLocal, ivaLocal) => {

        const listItem = products.map(item => ({
            item_id: item.product.id ? item.product.id :
                item.product.domain_section[0].domain_type === "register" ? "1" :
                item.product.domain_section[0].domain_type === "transfer" ? "2" :
                "3",
            item_name: (item.product.id) ? item.product.smallname : obtenerTLD(item.product.domain_section[0].dominio_principal),
            affiliation: "NEUBOX",
            discount: item.price.cross_price ? item.price.cost : "0",
            item_brand: "NEUBOX.COM",
            item_category: item.product.id ? item.product.name.split("-")[0].trim() : "Dominio",
            item_variant: item.periodo,
            price: item.price.second_price ? item.price.second_price : "0",
            quantity: 1,
            transaction_id: "",
        }));
    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "add_payment_info",
            ecommerce: {
                currency: currency,
                value: totalLocal,
                coupon: coupon,
                tax: ivaLocal,
                payment_type: paymentMethod === "Evo" ? "banamex" :
                    paymentMethod === "PayPal" ? "paypal" :
                    paymentMethod === "PayPalPlus" ? "paypalplus" :
                    paymentMethod === "Nbp" ? "neuboxpoints" :
                    paymentMethod === "Saf" ? "creditbalance" :
                    paymentMethod,
                items: listItem
            }
        });
    };

    return { sendBeginCheckoutEvent, sendAddPaymentInfoEvent };
}

export default eventosGTM;